import * as React from 'react';
import { Alert } from '@watcherr/ui';
import { WatcherrError } from '@watcherr/resources';
import { humaniseErrors } from '~utils/error';

interface ErrorContainerProps {
  error?: Error;
}

const ErrorContainer: React.FC<ErrorContainerProps> = ({ error }) => {
  if (!error) return null
  if (error instanceof WatcherrError) {
    const { title } = humaniseErrors(error)
    return <Alert type="error">{title}</Alert>
  }
  return <Alert type="error">{error.message}</Alert>;
};

export default ErrorContainer
